import { MultiSelectDropdown, MultiSelectDropdownProps } from "../../controls";
import FieldError from "../FieldError";
import FieldLabel from "../FieldLabel";
import FieldLayout from "../FieldLayout";

type Props = MultiSelectDropdownProps & {
  label: React.ReactNode;
  name: string;
  showError?: boolean;
  error?: React.ReactNode;
  size?: "small" | "medium";
};

export default function FormMultiSelectDropdown(props: Props) {
  const {
    name,
    label,
    error,
    showError = false,
    size = "medium",
    ...dropdownProps
  } = props;

  return (
    <FieldLayout showError={showError}>
      {{
        label: <FieldLabel htmlFor={name}>{label}</FieldLabel>,
        field: (
          <MultiSelectDropdown
            id={name}
            inputId={name}
            aria-labelledby={name}
            name={name}
            {...dropdownProps}
          />
        ),
        error: <FieldError>{error}</FieldError>
      }}
    </FieldLayout>
  );
}
